













































































































































































import debounce from "lodash/debounce";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  minLength,
  sameAs
} from "vuelidate/lib/validators";

import { getFieldError } from "@/core/tools/forms/get_field_error";

import { STORE_KEY, store } from "./_store";
import Attachments from "@/components/Controls/Attachments.vue";
import ParentProductCombobox from "@/components/Controls/ParentProductCombobox.vue";

@Component({
  mixins: [validationMixin],
  computed: {
    ...mapState(STORE_KEY, [
      "loaded",
      "loading",
      "fatalError",
      "document",
      "form",
      "meta"
    ]),
    ...mapGetters(STORE_KEY, ["fields"]),
    ...mapState("ubic", ["token"])
  },
  methods: {
    getFieldError
  },
  components: {
    Attachments,
    ParentProductCombobox
  },
  validations() {
    const rules: any = {
      name: { required, minLength: minLength(3) },
      code: {},
      position: {},
      promo_name: {},
      teaser: {},
      promo_image_url: {},
      pick_up_product: {},
      archived_at: {},
      type_id: { required }
    };

    return {
      form: rules
    };
  }
})
export default class ProductForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;

  document!: any;
  form!: any;
  public dropFiles = [];

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }
  FILES_HOST = process.env.VUE_APP_UBIC_SERVER_ADDRESS;

  public mounted() {
    console.log("this.isNew)", this.isNew);
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  changeValue(field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field,
      newValue: value
    });

    // @ts-ignore
    this.$v.form[field].$touch();
    // this.$v.form.$touch();
  }

  saveFormData() {
    this.$v.form.$touch();

    if (!this.$v.form.$error) {
      this.$store
        .dispatch(
          `${STORE_KEY}/saveForm`,
          this.documentPreview ? this.documentPreview.id : null
        )
        .then(result => {
          this.$buefy.snackbar.open(`Данные успешно сохранены`);
          this.$v.form.$reset();

          this.$emit("form-close");
          (this.$parent as any).close();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: `При сохранении возникли проблемы. Попробуйте позже.`
          });
        });
    }
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, { newValue: file });
  }

  removeFile(row: any, idx: number) {
    row.attachments.splice(idx, 1);
    this.saveFormData();
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}
